import type { SearchParams } from '@seek/chalice-types';

// Based on the logic from getRelatedSearchTerm
export const shouldRequestRelatedSearches = (searchParams: SearchParams) => {
  const { keywords, classification, subclassification } = searchParams;

  return keywords || classification || subclassification;
};
